const employeesData = [
  {
    id: 1,
    firstName: 'Rajesh',
    lastName: 'Kumar',
    email: 'rajesh.kumar@example.com',
    salary: '85000',
    date: '2022-01-15'
  },
  {
    id: 2,
    firstName: 'Neha',
    lastName: 'Sharma',
    email: 'neha.sharma@example.com',
    salary: '75000',
    date: '2022-01-16'
  },
  {
    id: 3,
    firstName: 'Amit',
    lastName: 'Singh',
    email: 'amit.singh@example.com',
    salary: '90000',
    date: '2022-01-17'
  },
  {
    id: 4,
    firstName: 'Sneha',
    lastName: 'Patel',
    email: 'sneha.patel@example.com',
    salary: '65000',
    date: '2022-01-18'
  },
  {
    id: 5,
    firstName: 'Aniket',
    lastName: 'Das',
    email: 'aniket.das@example.com',
    salary: '80000',
    date: '2022-01-19'
  },
  {
    id: 6,
    firstName: 'Laurena',
    lastName: 'Lurie',
    email: 'laurena@example.com',
    salary: '120000',
    date: '2019-07-30',
  },
  {
    id: 7,
    firstName: 'George',
    lastName: 'Tallman',
    email: 'george@example.com',
    salary: '90000',
    date: '2019-08-15',
  },
  {
    id: 8,
    firstName: 'Jesica',
    lastName: 'Watlington',
    email: 'jesica@example.com',
    salary: '60000',
    date: '2019-10-10',
  },
  {
    id: 9,
    firstName: 'Matthew',
    lastName: 'Warren',
    email: 'matthew@example.com',
    salary: '71000',
    date: '2019-10-15',
  },
  {
    id: 10,
    firstName: 'Lyndsey',
    lastName: 'Follette',
    email: 'lyndsey@example.com',
    salary: '110000',
    date: '2020-01-15',
  },
  {
    id: 11,
    firstName: 'John',
    lastName: 'Doe',
    email: 'johndoe@example.com',
    salary: '75000',
    date: '2022-01-15'
  },
  {
    id: 12,
    firstName: 'Jane',
    lastName: 'Doe',
    email: 'janedoe@example.com',
    salary: '85000',
    date: '2022-01-16'
  },
  {
    id: 13,
    firstName: 'Michael',
    lastName: 'Johnson',
    email: 'michaelj@example.com',
    salary: '90000',
    date: '2022-01-17'
  },
  {
    id: 14,
    firstName: 'Emily',
    lastName: 'Smith',
    email: 'emilysmith@example.com',
    salary: '65000',
    date: '2022-01-18'
  },
  {
    id: 15,
    firstName: 'William',
    lastName: 'Brown',
    email: 'williambrown@example.com',
    salary: '80000',
    date: '2022-01-19'
  },
  {
    id: 16,
    firstName: 'Susan',
    lastName: 'Jordon',
    email: 'susan@example.com',
    salary: '95000',
    date: '2019-04-11',
  },
  {
    id: 17,
    firstName: 'Adrienne',
    lastName: 'Doak',
    email: 'adrienne@example.com',
    salary: '80000',
    date: '2019-04-17',
  },
  {
    id: 18,
    firstName: 'Rolf',
    lastName: 'Hegdal',
    email: 'rolf@example.com',
    salary: '79000',
    date: '2019-05-01',
  },
  {
    id: 19,
    firstName: 'Kent',
    lastName: 'Rosner',
    email: 'kent@example.com',
    salary: '56000',
    date: '2019-05-03',
  },
  {
    id: 20,
    firstName: 'Arsenio',
    lastName: 'Grant',
    email: 'arsenio@example.com',
    salary: '65000',
    date: '2019-06-13',
  }
  
];

export { employeesData };
